import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ITServicesPage = lazy(() => import('../pages/services/it/page'));
const MediationPage = lazy(() => import('../pages/services/mediation/page'));
const ConsultingPage = lazy(() => import('../pages/services/consulting/page'));
const TechnicalPage = lazy(() => import('../pages/services/technical/page'));
const MarketingPage = lazy(() => import('../pages/services/marketing/page'));
const AutomationPage = lazy(() => import('../pages/services/automation/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/it',
    element: <ITServicesPage />,
  },
  {
    path: '/services/mediation',
    element: <MediationPage />,
  },
  {
    path: '/services/consulting',
    element: <ConsultingPage />,
  },
  {
    path: '/services/technical',
    element: <TechnicalPage />,
  },
  {
    path: '/services/marketing',
    element: <MarketingPage />,
  },
  {
    path: '/services/automation',
    element: <AutomationPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;